<template>
    <Dialog ref="dialog" :config="config" :beforeClose="beforeClose" :visible='visible' :cancelDialog="cancelDialog" :confirmDialog='confirmDialog'>
        <p>有凭证、期初数据或存在结账期间，无法再修改账套启用年月。因为已经有数据记录，则不能再修改账套启用期间</p>
    </Dialog>
</template>

<script>
import Dialog from "@/components/Dialog";

export default {
  props: {
    rowData:{
      type: Object,
    },
    type:{
      type: String,
    },
    visible: {
      type: Boolean,
    },
    cancel: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    Dialog,
  },
  data() {
    return {
      config: {
        top: '20vh',
        width: '21rem',
        title: '提示',
        center: true,
        btnTxt: ['确定'],
      },
    };
  },
  methods: {
    beforeClose(){
      this.cancel();
      console.log('关闭前');
    },
    cancelDialog(){
      this.cancel();
    },
    confirmDialog(){
      this.cancel();
    },
  }
};
</script>